import { useEffect, useRef } from 'react';

const CustomCursor = () => {
  const dotRef = useRef(null);
  const rafRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0 });
  const isOverImageRef = useRef(false);

  useEffect(() => {
    const handleMove = (e) => {
      posRef.current.x = e.clientX;
      posRef.current.y = e.clientY;

      // Check if hovering over an image
      const element = e.target;
      const isOverImage = element && (element.tagName === 'IMG' || element.closest('img'));

      // Check if this image is in the aboutImages container
      const isAboutImage = isOverImage && element.closest('.aboutImages');

      isOverImageRef.current = !!isOverImage;

      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          if (dotRef.current) {
            const { x, y } = posRef.current;
            dotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
            // Only change color for images NOT in aboutImages
            dotRef.current.style.backgroundColor = (isOverImageRef.current && !isAboutImage) ? '#ffe4ec' : '';
          }
          rafRef.current = null;
        });
      }
    };

    const handleTouchMove = (e) => {
      if (!e.touches || e.touches.length === 0) return;
      const t = e.touches[0];
      posRef.current.x = t.clientX;
      posRef.current.y = t.clientY;
      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          if (dotRef.current) {
            const { x, y } = posRef.current;
            dotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
          }
          rafRef.current = null;
        });
      }
    };

    window.addEventListener('mousemove', handleMove, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });
    // Set an initial random position so the dot does not sit at the top-left (0,0) on page load
    if (dotRef.current) {
      const rx = Math.max(8, Math.floor(Math.random() * window.innerWidth));
      const ry = Math.max(8, Math.floor(Math.random() * window.innerHeight));
      posRef.current.x = rx;
      posRef.current.y = ry;
      dotRef.current.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      dotRef.current.style.opacity = '1';
      dotRef.current.style.transition = 'opacity 0.3s ease, background-color 0.25s ease';
    }

    const handleDocLeave = () => {
      if (dotRef.current) dotRef.current.style.opacity = '0';
    };
    const handleDocEnter = () => {
      if (dotRef.current) dotRef.current.style.opacity = '1';
    };

    document.documentElement.addEventListener('mouseleave', handleDocLeave);
    document.documentElement.addEventListener('mouseenter', handleDocEnter);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('touchmove', handleTouchMove);
      document.documentElement.removeEventListener('mouseleave', handleDocLeave);
      document.documentElement.removeEventListener('mouseenter', handleDocEnter);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return <div ref={dotRef} className="stockDot customCursor" />;
};

export default CustomCursor;
